import { FormHelperText } from '@mui/material'

import withStyles from '@mui/styles/withStyles'

export default withStyles({
  root: {
    marginLeft: 31,
  },
})(FormHelperText)
